import { render } from "./CoachItem.vue?vue&type=template&id=3cdfeb9b&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=3cdfeb9b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cdfeb9b"

export default script